module.exports = __webpack_public_path__ + "static/media/cover16.306eaf25.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover16.png
// module id = 569
// module chunks = 0